import { Modal } from 'almanac-ui/Modal'
import { ConfirmModal } from 'hooks/useConfirmModal'

export const ConfirmCloseModal = ({ onCancel, onConfirm, onPressOutside }: ConfirmModal) => (
  <Modal.Root onPressOutside={onPressOutside}>
    <Modal.Header
      title="Are you sure you want to close?"
      subHeader="If you close now, all your changes will be lost."
      isConfirmation
    />
    <Modal.Footer isConfirmation>
      <Modal.FooterContent slot="left">
        <Modal.FooterButton onPress={onCancel} size="lg" variant="secondary">
          Cancel
        </Modal.FooterButton>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Modal.FooterButton onPress={onConfirm} size="lg" variant="primary">
          Confirm
        </Modal.FooterButton>
      </Modal.FooterContent>
    </Modal.Footer>
  </Modal.Root>
)
